export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/def6b846dff0553eb3d137534f42c853.jpg"
          alt="Elderly Care Facility"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Top Right Banner */}
      <div className="absolute top-24 right-0 bg-orange-500 px-8 py-4 shadow-lg z-20">
        <div className="flex items-center space-x-2 text-white">
          <i className="ri-flag-line text-xl"></i>
          <span className="text-sm font-bold tracking-wide">SAFETY·INTEGRITY·EXCELLENCE·PEOPLE-CENTRIC</span>
        </div>
        <div className="text-white text-sm font-medium mt-1">
          安全、誠信、卓越、以人為本
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        {/* Company Name */}
        <div className="mb-8">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-3 tracking-tight">
            <span className="text-orange-500">CORE UNITY</span> LIMITED
          </h1>
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-wide">
            康顧有限公司
          </h2>
        </div>

        {/* Company Introduction */}
        <div className="max-w-4xl mx-auto mb-10">
          <p className="text-lg md:text-xl text-white/95 leading-relaxed">
            康顧由一支擁有逾<strong className="text-orange-400">20年行業經驗</strong>的管理團隊領航，並以逾<strong className="text-orange-400">100人</strong>的跨專業醫護團隊為堅實後盾，深諳院舍營運的各種挑戰。我們透過三大核心業務，為私營院舍、NGO及長者日間中心提供前瞻性、全方位的解決方案，助您輕鬆應對營運挑戰，全面提升院舍競爭力。
          </p>
        </div>

        {/* CTA Button */}
        <div className="flex items-center justify-center">
          <a
            href="#about"
            className="group px-10 py-4 bg-orange-500 text-white font-bold text-lg rounded-full hover:bg-orange-600 transition-all duration-300 flex items-center space-x-3 whitespace-nowrap cursor-pointer shadow-xl hover:shadow-2xl"
          >
            <span>了解更多</span>
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}